import React, { FC, useContext, useEffect } from "react";
import SimpleModal from "common/components/dialogs/SimpleModal";
import { Button, DialogActions } from "@mui/material";
import theme from "common/theme/theme";
import { LanguageContext } from "common/contexts/LanguageContext";
import { useAuthContext } from "common/contexts/AuthContext";
import { SharedProjectContext } from "components/project/Project";
import { useAuth0 } from '@auth0/auth0-react';

interface IProps {
  title: string;
  isOpen: boolean;
  setOpen: () => void;
}

const GuestUser: FC<IProps> = (props) => {
  const { title, isOpen, setOpen } = props;

  const { getString } = useContext(LanguageContext);
  const { login } = useAuthContext();
  const { setIsBusyBackgroundActive } = useContext(SharedProjectContext);
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    setIsBusyBackgroundActive(isOpen);
  }, [isOpen, setIsBusyBackgroundActive])

  return (
    <SimpleModal title={title} maxWidth="sm" isOpen={isOpen} setOpen={setOpen}>
      <DialogActions sx={{justifyContent: 'center', paddingTop:'24px'}}>
              <Button variant="text" onClick={async () => loginWithRedirect({
                  authorizationParams: {
                      'ext-returnPath': '/en-us/',
                      'ext-returnuri': 'https://q.wirelessplanning.emerson.com',
                      'ext-redirectURI': 'https://q.wirelessplanning.emerson.com/en-us'
                  }
              })}>
          {getString("wlcm_createact")}
        </Button>
        <Button
          key={getString("cmn_cancel").replace(/\s/g, "")}
          autoFocus={true}
          sx={{
            margin: 0,
            padding: theme.spacing(1, 2),
            justifyContent: "center",
          }}
          variant="contained"
          color="primary"
          onClick={setOpen}
          data-testid={`${getString("cmn_cancel").replace(/ /g, "")}Input`}
        >
          {getString("cmn_cancel")}
        </Button>
      </DialogActions>
    </SimpleModal>
  );
};

export default GuestUser;
